import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import { V2Cta, V2Frame } from '../sections/v2';
import { LandingVariantProps } from './types';

/**
 * LP1 new-UX (`phone-only-v1`) — call-centre only. Also rendered when a `-v1`
 * design needs an online link the locale lacks (see useResolvedLandingVariant).
 *
 * The trailing ` **` on the heading anchors the "** Hotline …" footnote
 * (26-Aug-2026 feedback); it is appended here, not baked into translations.
 * The dial link prefers the variant override — the new-UX pages advertise
 * different numbers in some countries for call-centre A/B attribution.
 */
export const PhoneOnlyV1: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => {
  const phoneHref = copy.ctaPhoneLink ?? data.ctaPhoneLink;
  return (
    <V2Frame
      data={data}
      copy={copy}
      singleCta
      cta={
        <V2Cta heading={`${copy.registration} **`} subCopy={copy.phoneSubCopy}>
          <ButtonLink
            leftIcon={Phone()}
            href={phoneHref}
            variant="secondary"
            id="phone-cta"
            onClick={() => onCtaClick('phone', phoneHref)}
          >
            {copy.ctaPhoneText}
          </ButtonLink>
        </V2Cta>
      }
    />
  );
};
